module.exports = __webpack_public_path__ + "1120a67284ec2ce155fe526df7c6c1b1.jpg";